module.exports = __webpack_public_path__ + "img/traveller_inactive.64ccafd6.svg";